import { useBankProfile } from '@contexts/BankProfileContext';
import { useCCFeatureFlagsContext } from '@contexts/CCFeatureFlagContext';
import apiClient from '@services/apiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isGuruPayAppSession } from '@utils/utils';
import { CC_FEATURE_FLAGS } from 'types/layout';

import type { PendingLegalDocument } from './useProfiles';
import { LEGAL_DOCUMENT_TYPES, useProfiles } from './useProfiles';

export const usePendingLegalDocuments = () => {
	const isAppSession = isGuruPayAppSession();
	const { data, isPending } = useProfiles();
	// TODO remove with FF task
	const { selectedProfile } = useBankProfile();
	const { hasFeature, isFetched: areFlagsFetched } = useCCFeatureFlagsContext();

	if (!isAppSession) {
		return { documents: [], isChecking: false };
	}

	const documents = selectedProfile
		? (data?.pending_legal_documents?.filter(({ type }) =>
				LEGAL_DOCUMENT_TYPES.includes(type),
			) ?? [])
		: [];
	// TODO remove with FF task and return documents with isChecking: isPending
	const isChecking = isPending || (documents.length > 0 && !areFlagsFetched);

	return {
		documents:
			!isChecking && hasFeature(CC_FEATURE_FLAGS.LEGAL_CONSENT_SCREEN) ? documents : [],
		isChecking,
	};
};

export const useAcceptLegalDocuments = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (documents: PendingLegalDocument[]) =>
			apiClient.post('/users/legal-documents/acceptances', {
				uuids: documents.map(({ uuid }) => uuid),
			}),
		meta: { suppressGlobalErrors: true },
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['profiles'] }),
	});
};
